import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 20px;
`

export const ModalBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > div {
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }
`

export const Input = styled.input`
  height: 30px;
  width: 92%;
  overflow: hidden;
  margin: 18px;
  padding: 10px 4px;
  resize: none;
  outline: none;
  border: 2px solid rgba(98, 147, 97, 0.15);
  border-radius: 6px;
  font-size: 14px;
`

export const LogDetail = styled.div`
  padding: 12px 16px;
  background: #f9f9f9;
  border-bottom: 1px solid #e0e0e0;
  font-size: 13px;
  color: #555;

  code {
    background: #eef2f7;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 12px;
  }
`;

export const LogRow = styled.div<{ $isExpanded: boolean }>`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 8px;
  padding: 10px 12px;
  cursor: pointer;
  background: ${props => props.$isExpanded ? '#f0f7ff' : 'white'};
  border-bottom: 1px solid #eee;
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
export const Table = styled.table`
  width:100%;

`;

export const FiltersContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px; /* добавим отступ между селектами */
    margin-bottom: 16px;
    flex-wrap: wrap; /* если не влазят — переносим */
`;

export const FilterButton = styled.select`
    min-width: 180px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background-color: white;
    font-size: 14px;
    color: #333;
    cursor: pointer;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }

    option {
        font-size: 14px;
        padding: 4px;
    }
`;
export const Button = styled.button`
    min-width: 180px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background-color: white;
    font-size: 14px;
    color: #333;
    cursor: pointer;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }

    option {
        font-size: 14px;
        padding: 4px;
    }
`;
export const LogTable = styled.tbody`
  width:100%;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
`;
export const TabContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
  width: 100%;
`;

export const Tab = styled.button<{ $isActive: boolean }>`
  padding: 8px 16px;
  background: ${props => (props.$isActive ? '#007bff' : '#f8f9fa')};
  color: ${props => (props.$isActive ? 'white' : '#495057')};
  border: none;
  border-radius: 6px 6px 0 0;
  font-weight: ${props => (props.$isActive ? 'bold' : 'normal')};
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;

  &:hover {
    background: ${props => (props.$isActive ? '#0056b3' : '#e9ecef')};
  }
`;

export const Td = styled.td`
  padding: 2px 4px;

`;

export const IsUnreadTr = styled.tr<{ $isUnread: boolean }>`
background: ${props => (props.$isUnread ? '#F0F8FF' : 'inherit')};
width:100%;
`;

export const DateInput = styled.input`
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
`;